/* eslint-disable react/prop-types */
import React, { lazy, useEffect } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import Billing from "src/views/collegeBilling/Billing";
import Users from "src/views/Users/Users";
import PlanMaster from "src/views/Plans/Plans";
import PrintOne from "src/views/counterBilling/print/PrintOne";
import SalesReport from "src/views/reports/SalesReport";
import SalesReportPrint from "src/views/counterBilling/print/SalesPrint";
import QuotationBill from "src/views/quotation";
import CollegeQuotation from "src/views/CollegeQuotation";
import DeliveryReport from "src/views/reports/DeliveryReport";
import DeliveryReportPrint from "src/views/counterBilling/print/DeliveryPrint";
import { useDispatch, useSelector } from "react-redux";
import { CommonPrivFilter } from "src/redux/privileges/Privileges";
import { getPrivileges } from "src/redux/privileges/PrivilegesThunk";
import Loader from "src/components/Loader";

const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));

const Banner = Loadable(lazy(() => import("../views/banner/Banner")));
const Service = Loadable(lazy(() => import("../views/service/Service")));
const Testimonial = Loadable(
  lazy(() => import("../views/testimonial/Testimonial"))
);
const OrderList = Loadable(lazy(() => import("../views/Order/OrderList")));

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Login = Loadable(lazy(() => import("../views/authentication/Login")));

// master imports
const CreateProduct = Loadable(
  lazy(() => import("src/views/master/CreateProduct"))
);
const Hostel = Loadable(lazy(() => import("src/views/master/Hostel")));
const BagMaster = Loadable(lazy(() => import("src/views/master/BagMaster")));
const TypeMaster = Loadable(lazy(() => import("src/views/master/TypeMaster")));
const RoomMaster = Loadable(lazy(() => import("src/views/master/RoomMaster")));
const CategoryMaster = Loadable(
  lazy(() => import("src/views/master/CategoryMaster"))
);
const CollegePrice = Loadable(
  lazy(() => import("src/views/master/CollegePrice"))
);
const Staff = Loadable(lazy(() => import("src/views/master/Staff")));
const StudentMaster = Loadable(
  lazy(() => import("src/views/master/StudentMaster"))
);
const CounterBill = Loadable(lazy(() => import("src/views/counterBilling")));

// reports
const StudentOutstanding = Loadable(
  lazy(() => import("src/views/reports/StudentOutstanding"))
);
const BagTab = Loadable(lazy(() => import("src/views/reports/BagTab")));
const BillSummary = Loadable(
  lazy(() => import("src/views/reports/BillSummary"))
);

function ProtectedRoute({ isAllowed, children }) {
  return isAllowed ? children : <Navigate to="/404" />;
}

function Routes() {
     const {loading} = useSelector((state) => state?.privilegeSlice);

    function filterRoutes(routes) {
 const predicate= (route)=>!route?.ref ? true :CommonPrivFilter(route.ref)?.canRead
  // Check if current route passes the predicate
  const matches = predicate(routes);

  
  
  // Recursively filter children if they exist
  let filteredChildren = [];
  if (routes.children?.length > 0 && Array.isArray(routes.children)) {
    filteredChildren = routes.children
      .map(child => filterRoutes(child))
      .filter(Boolean);
      
  }
  console.log(filteredChildren);
  

  // Return route if it matches or has matching children
       if (matches && filteredChildren.length > 0) {
     
          return {
            ...routes,
            children: filteredChildren,
          };
        }if(matches){
      
        return routes
        }

  // Otherwise exclude the route
  return  {
            ...routes,
            element:<Navigate to="/404" />,
            children: filteredChildren.length > 0?filteredChildren:null,
          };
}
   const dispatch=useDispatch()
     useEffect(() => {
      dispatch(getPrivileges());
    }, [dispatch]);
  const isLaundry = localStorage.getItem("isLaundry") === "true" ? true : false;
const routes= useRoutes([
    filterRoutes({
      path: "/",
      element: <FullLayout />,
      children: [
        { path: "/", element: <Navigate to="/master/product" /> },
        // { path: 'dashboard', element: <Dashboard /> },
        { path: "banner", element: <Banner /> ,ref:"adminconsole-banner"},
        { path: "service", element: <Service />,ref:"adminconsole-service" },
        { path: "testimonial", element: <Testimonial />,ref:"adminconsole-testimonial" },
        { path: "orders", element: <OrderList />,ref:"adminconsole-laundry-orders" },
        { path: "users", element: <Users />,ref:"adminconsole-laundry-users" },
        { path: "plans", element: <PlanMaster />,ref:"adminconsole-laundry-plans" },

        { path: "college_bill", element: <Billing />,ref:"adminconsole-laundry-college-bill" },
        { path: "college_quotation", element: <CollegeQuotation/>,ref:"adminconsole-laundry-college-quotation" },

        // masters
        { path: "master/product", element: <CreateProduct />,ref:"" },
        {
          path: "master/hostel",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <Hostel />
            </ProtectedRoute>
          ),
          ref:"adminconsole-laundry-hostel"
        },
        {
          path: "master/bag",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <BagMaster />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-bag"
        },
        {
          path: "master/type_master",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <TypeMaster />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-type-master"
        },
        {
          path: "master/room",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <RoomMaster />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-room"
        },
        { path: "master/category", element: <CategoryMaster />,ref:"adminconsole-category" },
        {
          path: "master/college",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <CollegePrice />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-college-price"
        },
        { path: "master/staff", element: <Staff /> ,ref:"adminconsole-staff"},
        {
          path: "master/student",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <StudentMaster />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-student"
        },

        // reports (protected routes)
        {
          path: "report/student-outstanding",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <StudentOutstanding />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-student-outstanding"
        },
        {
          path:"report/sales-report",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <SalesReport />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-bill-report"
        },
        {
          path:"report/delivery-report",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <DeliveryReport />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-delivery-report"
        },
        {
          path: "report/bag-report",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <BagTab />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-bag-report"
        },
        {
          path: "report/bill-summary",
          element: (
            <ProtectedRoute isAllowed={isLaundry}>
              <BillSummary />
            </ProtectedRoute>
          ),ref:"adminconsole-laundry-bill-summary"
        },
      ],
    }),
    filterRoutes({ path: "counterBilling", element: <CounterBill /> ,ref:"adminconsole-laundry-counterbilling"}),
    filterRoutes({ path: "quotationBilling", element: <QuotationBill />,ref:"adminconsole-laundry-quotationbilling" }),
   filterRoutes({ path: "print_one", element: <PrintOne />,ref:"" }),
    filterRoutes({ path: "sales_report_print", element: <SalesReportPrint /> ,ref:""}),
    filterRoutes({ path: "delivery_report_print", element: <DeliveryReportPrint />,ref:"" }),
    filterRoutes({ path: "404", element: <Error /> ,ref:""}),
    filterRoutes({ path: "auth/login", element: <Login /> ,ref:""}),
    filterRoutes({ path: "*", element: <Navigate to="/404" />,ref:"" }),
  ]);
    if(loading){

return <Loader start={loading} />
  }
  return routes
}

export default Routes;
